export default "__VITE_ASSET__BNZ4FgtC__"